import * as React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { user } from "../../../redux/usersSlice";
import { persistUserAuthSession } from "../utils/authUtils";

export function useLoginWrapperState() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [pendingPasswordChange, setPendingPasswordChange] = React.useState({
    showChangePassword: false,
    userData: null,
    authToken: null,
    refreshToken: null,
    url: null,
  });

  const clearPendingPasswordChange = React.useCallback(() => {
    setPendingPasswordChange({
      showChangePassword: false,
      userData: null,
      authToken: null,
      refreshToken: null,
      url: null,
    });
  }, []);

  const handleLogin = React.useCallback(
    (response, url) => {
      const { token, user_data, password_changed } = response;

      if (!password_changed) {
        setPendingPasswordChange({
          showChangePassword: true,
          userData: user_data,
          authToken: token?.access_token,
          refreshToken: token?.refresh_token,
          url,
        });
        return;
      }

      dispatch(user(user_data));
      persistUserAuthSession({
        token,
        userData: user_data,
      });
      navigate(url);
    },
    [dispatch, navigate]
  );

  const handlePasswordChangeSuccess = React.useCallback(() => {
    dispatch(user(pendingPasswordChange.userData));
    persistUserAuthSession({
      token: {
        access_token: pendingPasswordChange.authToken,
        refresh_token: pendingPasswordChange.refreshToken,
      },
      userData: pendingPasswordChange.userData,
    });
    const nextUrl = pendingPasswordChange.url;
    clearPendingPasswordChange();
    navigate(nextUrl);
  }, [clearPendingPasswordChange, dispatch, navigate, pendingPasswordChange]);

  return {
    showChangePassword: pendingPasswordChange.showChangePassword,
    userData: pendingPasswordChange.userData,
    authToken: pendingPasswordChange.authToken,
    handleLogin,
    handlePasswordChangeSuccess,
  };
}
